<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <form @submit.prevent="submit" v-if="supplierCategory">
          <fg-input label="Name"
            type="text"
            v-model="supplierCategory.name"
            :error="valErrors['name'] ? valErrors['name'][0] : null"
          />
          <button type="submit" class="btn btn-fill btn-info">Speichern</button>
        </form>
      </card>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      supplierCategory: null,
      valErrors: []
    }
  },
  methods: {
    async submit () {
      await this.initCsrf()

      this.valErrors = []
      this.$http.put(`/supplier_categories/${this.supplierCategory.id}`, this.supplierCategory).then(({ data }) => {
        this.$notify({
          message: 'Lieferanten Tag erfolgreich bearbeitet.',
          type: 'success'
        })
        this.$router.push('/supplier_categories')
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    }
  },
  created () {
    this.$http.get(`/supplier_categories/${this.$route.params.id}`).then(({ data }) => {
      this.supplierCategory = data
    })
  }
}
</script>

<style>
</style>
